"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var StyleButton = _styledComponents["default"].button.withConfig({
  displayName: "Buttonstyle__StyleButton",
  componentId: "sc-1xdbh20-0"
})(["", ";"], function (props) {
  var _props$theme = props.theme,
    palette = _props$theme.palette,
    spacing = _props$theme.spacing,
    typography = _props$theme.typography,
    genericBorderRadius = _props$theme.extra.genericBorderRadius;
  var disabled = props.disabled,
    fullWidth = props.fullWidth,
    variant = props.variant,
    medium = props.medium,
    icon = props.icon,
    capitalization = props.capitalization;
  var colors = {};
  switch (variant) {
    case 'naked':
      {
        colors = {
          normal: {
            border: palette.secondary,
            background: 'transparent',
            text: palette.secondary
          },
          hover: {
            border: palette.primary,
            background: palette.accent.delta,
            text: palette.primary
          }
        };
        break;
      }
    case 'link':
      {
        colors = {
          normal: {
            border: 'none',
            background: 'transparent',
            text: palette.secondary
          }
        };
        colors.hover = colors.normal;
        break;
      }
    case 'primary':
    default:
      {
        colors = {
          normal: {
            border: palette.secondary,
            background: palette.secondary,
            text: palette.basic.white
          },
          hover: {
            border: palette.primary,
            background: palette.primary,
            text: palette.basic.white
          }
        };
        break;
      }
  }
  if (disabled) {
    colors = {
      normal: {
        border: palette.gray.charlie,
        background: palette.gray.charlie,
        text: palette.basic.white
      }
    };
    colors.hover = colors.normal;
  }
  return (0, _styledComponents.css)(["cursor:pointer;width:", ";outline:none;", " ", ";", ";", ";", ";"], fullWidth ? '100%' : 'auto', variant === 'link' && (0, _styledComponents.css)(["background:none;border:none;color:", ";font-family:inherit;font-size:inherit;font-style:inherit;padding:0;text-decoration:underline;text-transform:inherit;", ";"], palette.secondary, disabled && (0, _styledComponents.css)(["color:", ";"], palette.gray.charlie)), variant !== 'link' && variant !== 'text' && (0, _styledComponents.css)(["background-color:", ";border:1px solid ", ";border-radius:", ";color:", ";font-family:", ";font-size:", ";font-weight:", ";min-width:96px;padding:", " ", ";text-transform:", ";transition:background-color .2s ease-in-out;", " ", " ", ""], colors.normal.background, colors.normal.border, genericBorderRadius, colors.normal.text, typography.font.primary, typography.size.paragraph, typography.weight.semiBold, spacing.xxSmall, spacing.base, capitalization, medium && (0, _styledComponents.css)(["min-width:", ";padding:", " ", ";"], spacing.basePlus, spacing.tiny, spacing.small), icon && (0, _styledComponents.css)([".button-icon{margin-right:", ";line-height:0.5;position:relative;top:2px;}"], spacing.small), !disabled && (0, _styledComponents.css)(["&:hover{background-color:", ";border-color:", ";color:", ";}"], colors.hover.background, colors.hover.border, colors.hover.text)), variant === 'text' && (0, _styledComponents.css)(["color:", ";background-color:'transparent';.button-icon{margin-right:", ";line-height:0.5;position:relative;top:2px;}"], palette.gray.charlie, spacing.tiny), variant === 'naked' && (0, _styledComponents.css)(["", ";"], disabled && (0, _styledComponents.css)(["color:", ";border-color:", ";background-color:", ";"], palette.gray.charlie, palette.gray.charlie, palette.basic.white)), disabled && (0, _styledComponents.css)(["cursor:not-allowed;"]));
});
StyleButton.displayName = 'StyleButton';
var _default = exports["default"] = StyleButton;